import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ariaDescribedByIds, enumOptionsDeselectValue, enumOptionsIsSelected, enumOptionsSelectValue, enumOptionsValueForIndex, optionId } from '@rjsf/utils';
/** The `CheckboxesWidget` is a widget for rendering checkbox groups.
 *  It is typically used to represent an array of enums.
 *
 * @param props - The `WidgetProps` for this component
 */

function CheckboxesWidget(_ref) {
  var id = _ref.id,
      disabled = _ref.disabled,
      _ref$options = _ref.options,
      _ref$options$inline = _ref$options.inline,
      inline = _ref$options$inline === void 0 ? false : _ref$options$inline,
      enumOptions = _ref$options.enumOptions,
      enumDisabled = _ref$options.enumDisabled,
      emptyValue = _ref$options.emptyValue,
      value = _ref.value,
      _ref$autofocus = _ref.autofocus,
      autofocus = _ref$autofocus === void 0 ? false : _ref$autofocus,
      readonly = _ref.readonly,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus;
  var checkboxesValues = Array.isArray(value) ? value : [value];
  var handleBlur = useCallback(function (_ref2) {
    var target = _ref2.target;
    return onBlur(id, enumOptionsValueForIndex(target && target.value, enumOptions, emptyValue));
  }, [onBlur, id]);
  var handleFocus = useCallback(function (_ref3) {
    var target = _ref3.target;
    return onFocus(id, enumOptionsValueForIndex(target && target.value, enumOptions, emptyValue));
  }, [onFocus, id]);
  return _jsx("div", {
    className: 'checkboxes',
    id: id,
    children: Array.isArray(enumOptions) && enumOptions.map(function (option, index) {
      var checked = enumOptionsIsSelected(option.value, checkboxesValues);
      var itemDisabled = Array.isArray(enumDisabled) && enumDisabled.indexOf(option.value) !== -1;
      var disabledCls = disabled || itemDisabled || readonly ? 'disabled' : '';

      var handleChange = function handleChange(event) {
        if (event.target.checked) {
          onChange(enumOptionsSelectValue(index, checkboxesValues, enumOptions));
        } else {
          onChange(enumOptionsDeselectValue(index, checkboxesValues, enumOptions));
        }
      };

      var checkbox = _jsxs("span", {
        children: [_jsx("input", {
          type: 'checkbox',
          id: optionId(id, index),
          name: id,
          checked: checked,
          value: String(index),
          disabled: disabled || itemDisabled || readonly,
          autoFocus: autofocus && index === 0,
          onChange: handleChange,
          onBlur: handleBlur,
          onFocus: handleFocus,
          "aria-describedby": ariaDescribedByIds(id)
        }), _jsx("span", {
          children: option.label
        })]
      });

      return inline ? _jsx("label", {
        className: "checkbox-inline ".concat(disabledCls),
        children: checkbox
      }, index) : _jsx("div", {
        className: "checkbox ".concat(disabledCls),
        children: _jsx("label", {
          children: checkbox
        })
      }, index);
    })
  });
}

export default CheckboxesWidget;